import React from "react";
import NoDataIcon from "./../../../assets/icons/NoData.svg";
import { isNonZero } from "@Helpers/numberCondition";
import { useUiNext } from "@Utils/uiNext";

/** The root size the `width` / `height` numbers are designed at (1rem = 16 px). */
const DESIGN_ROOT_PX = 16;
/** The image's default width / height attribute (px at a 16 px root). */
const DEFAULT_IMAGE_PX = 300;

/** Every prop is optional: `dragList` passes only `text1`, `CreateTransmittal` adds width/height,
 *  and `svg` overrides the default icon. All have runtime fallbacks below. */
type NoDataSvgProps = {
  svg?: string;
  /** The image's width in px at a 16 px root (default 300). The new UI draws it in rem, so it follows the root. */
  width?: number;
  /** The image's height attribute (default 300): only its aspect hint before the image loads (CSS height is auto). */
  height?: number;
  text1?: React.ReactNode;
  text2?: React.ReactNode;
  /** Font-size utility for `text1`; colour, weight and spacing stay fixed. */
  text1Size?: string;
};

const NoDataSvg = (props: NoDataSvgProps) => {
  const uiNext = useUiNext();
  const imageWidthPx = isNonZero(props.width) ? props.width : DEFAULT_IMAGE_PX;
  return (
    <div className="flex flex-col justify-center items-center">
      <img
        src={props.svg ? props.svg : NoDataIcon}
        alt="No data"
        width={imageWidthPx}
        height={isNonZero(props.height) ? props.height : DEFAULT_IMAGE_PX}
        // New UI: the width attribute is px, which does not follow production's root (below 16 px at some widths);
        // the same width in rem overrides it (identical at a 16 px root). Classic keeps the attribute alone.
        style={uiNext ? { width: `${imageWidthPx / DESIGN_ROOT_PX}rem` } : undefined}
      />
      {props.text1 && (
        <div className={`text-text_light ${props.text1Size ?? "text-lg"} font-semibold mt-4 text-center`}>
          {props.text1}
        </div>
      )}
      {props.text2 && <div className="mt-2 text-center">{props.text2}</div>}
    </div>
  );
};

export default NoDataSvg;
